import wixData from 'wix-data';
import wixLocation from 'wix-location';
// For full API documentation, including code examples, visit http://wix.to/94BuAAs
$w.onReady(function () {
	loadRelatedProducts();
});

///-------------------STEP 3------------------
///  Create the loadRelatedProducts Function
async function loadRelatedProducts() {
	let product = await $w('#productPage').getProduct();
	let relatedProductResults = await Promise.all([
		relatedProductsByTable(product),
		relatedProductsByPrice(product)
	]);

	if (relatedProductResults[0].length > 0) {
		showRelatedProducts(relatedProductResults[0]);
	} else {
		showRelatedProducts(relatedProductResults[1]);
	}
}

///-----------------STEP 5----------------
///  Create the relatedProductByPrice Function
async function relatedProductsByPrice(product) {
	let productId = product._id;

	/// find related products by price
	let relatedByPrice = await wixData.query('Stores/Products')
		.between('price', product.price * 0.8, product.price * 1.2)
		.ne('_id', productId)
		.find();
	return relatedByPrice.items;
}
///--------------------------STEP4----------------
/// Create the relatedProductsByTable Function.
async function relatedProductsByTable(product) {
	let productId = product._id;

	// find related products by relation table
	let relatedByTable = await Promise.all([
		wixData.query('relatedProducts')
		.eq('productA', productId)
		.include('productB')
		.find(),
		wixData.query('relatedProducts')
		.eq('productB', productId)
		.include('productA')
		.find()
	]);

	let relatedProducts = [
		...relatedByTable[0].items.map(_ => _.productB),
		...relatedByTable[1].items.map(_ => _.productA)
	];
	return relatedProducts;
}

///--------------------STEP6--------------
///  Create the showRelatedProducts Function.
function showRelatedProducts(relatedProducts) {
	if (relatedProducts.length > 0) {
		relatedProducts.splice(5, relatedProducts.length);
		$w('#relatedItemsRepeater').onItemReady(relatedItemReady);
		$w("#relatedItemsRepeater").data = relatedProducts;
		$w("#relatedItems").expand();
	} else {
		$w("#relatedItems").collapse();
	}
}

//---------STEP7---------------
///  Create the relatedItemReady Function
function relatedItemReady($w, product) {
	$w("#productImage").src = product.mainMedia;
	$w("#productName").text = product.name;
	$w("#productPrice").text = product.formattedPrice;
	$w('#productImage').onClick(() =>
	 {	
	///	 wixLocation.to(product.productPageUrl);
    	 wixLocation.to("https://www.tavlinim.co.il/product-page/" + product.slug);
	///	 wixLocation.to("https://www.tavlinim.co.il" + product.slug);
	
	});
}